import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../../../service/server/server.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-cheque-select',
  templateUrl: './cheque-select.component.html',
  styleUrls: ['./cheque-select.component.scss']
})
export class ChequeSelectComponent implements OnInit, OnDestroy {
  public isOnline: any | undefined;
  public loading = false;
  user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  user_id: number | undefined;
  lang: number = 1;
  public subscription: Subscription | any;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  list_cheque: any = [];
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  public dataSource: any | undefined;
  user: number | undefined;
  document_type: number | undefined;
  token: any | undefined;
  type: any | undefined;


  displayedColumns = ['row', 'type', 'title', 'user', 'bank', 'account', 'cheque_number', 'date3', 'price', 'financial'];

  constructor(public serverService: ServerService, public router: Router, public matSnackBar: MatSnackBar,
    private matDialogRef: MatDialogRef<ChequeSelectComponent>
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any) {
    if (dialog_data) {
      this.user = dialog_data.user;
      this.document_type = dialog_data.document_type;
      this.token = dialog_data.token;
      this.type = dialog_data.type;
    }
  }//end consructor

  ngOnInit() {
    this.get_data();
  }

  get_data() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    //else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1928, user: this.user, document_type: this.document_type, token: this.token, type: this.type }).subscribe(
      (res: any) => {
        this.list_cheque = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_cheque.push(res['result'][i]);
          }//end for
          this.dataSource = new MatTableDataSource(this.list_cheque);
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  select(i: number) {
    this.matDialogRef.close({ result: this.list_cheque[i] });
  }

  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 8000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 8000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
